import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/** The status icons, each of which is served from assets/icons under its own name. */
const StatusIconNames: string[] = [
  'icon-degraded',
  'icon-healthy',
  'icon-planned-maintenance',
  'icon-unhealthy',
  'icon-unknown'
];

/**
 * Registers the status page's SVG icons with Material's icon registry (was the StatusModule
 * constructor). The components reference them by name through `svgIcon`, and the registry is
 * root provided, so this registers once at startup rather than when the status route loads.
 */
export function provideStatusIcons(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    for (const name of StatusIconNames) {
      iconRegistry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${name}.svg`));
    }
  });
}
